<div class="main-container">
  <div *ngIf="productionJob.status !== productionJobRunStatus.NeedValidation">
    Production Job has already been validated.
  </div>
  <div *ngIf="productionJob.status === productionJobRunStatus.NeedValidation">
    <mat-card appearance="outlined" *ngFor="let validation of validators" style="margin:2px 0px;">
      <mat-card-title style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
        <div style="display: flex; flex-direction: column; width: 100%;">
          <div style="display: flex; flex-direction: row; justify-content: space-between;">
            <div>
              <mat-panel-title>
                {{validation.displayName}}
              </mat-panel-title>
            </div>
            <div>
              <mat-icon *ngIf="step !== validation.id && validation.initiated">check</mat-icon>
              <mat-icon *ngIf="step === validation.id && expandedId === validation.id" [color]="validation.type === ValidationType.Warning ?  'accent' : 'warn'">
                {{validation.type === ValidationType.Warning ?  'warning' : 'error'}}
              </mat-icon>

            </div>
          </div>
          <mat-progress-bar *ngIf="step === validation.id && valiating" mode="indeterminate" color="accent" class="loading-accent-color-foreground"></mat-progress-bar>
        </div>
      </mat-card-title>
      <mat-card-content *ngIf="expandedId === validation.id" class="content">
        <div [innerHTML]="validation.content"></div>
        <br />
        <div><b>Failed Validation Count:</b> {{triggeredValidationCount}} </div>
        <br />
        <div>View in <button mat-button color="primary" [routerLink]="[]" (click)="goToBrowse(validation)">Browse</button></div>
        <div *ngIf="displayActionOption(validation.validator)">
          <span>Correct documents failing validation by coding them {{getField(validation.validator)}}</span>
          <button id="applyCoding.{{productionJob.productionJobId}}" mat-button color="primary" (click)="validationActions(validation)">Apply Coding</button>
        </div>

      </mat-card-content>
      <mat-card-actions style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;" *ngIf="expandedId === validation.id">
        <button mat-button id="acceptWarning.{{productionJob.productionJobId}}" *ngIf="validation.type === ValidationType.Warning" color="primary" (click)="nextStep()">Accept</button>
      </mat-card-actions>
    </mat-card>
    <mat-card appearance="outlined">
      <mat-card-title style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex;">
        <div style="display: flex; flex-direction: column; width: 100%;">
          <div style="display: flex; flex-direction: row; justify-content: space-between">
            <mat-panel-title>
              Validated
            </mat-panel-title>
            <div>
              <mat-icon *ngIf="step === validators.length">check</mat-icon>
            </div>
          </div>
        </div>
      </mat-card-title>
      <mat-card-content *ngIf="step === validators.length">
        The production has been validated.
      </mat-card-content>
      <mat-card-actions *ngIf="step === validators.length" style="place-content: stretch flex-end; align-items: stretch; flex-direction: row; box-sizing: border-box; display: flex;">
        <button id="finishProductionValidation.{{productionJob.productionJobId}}" mat-button color="primary" (click)="nextStep()">Finish</button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
